import { getPlanFeaturesForDisplay } from "../services/usageService";

/**
 * Public marketing pricing tiers (aligned with in-app plans).
 * @type {ReadonlyArray<{
 *   name: string,
 *   price: string,
 *   cadence: string,
 *   description: string,
 *   features: string[],
 *   cta: string,
 *   highlight?: boolean
 * }>}
 */
export const PRICING_PLANS = [
  {
    name: "Free",
    price: "$0",
    cadence: "/mo",
    description: "Test Quill AI with no credit card required.",
    features: [...getPlanFeaturesForDisplay("free"), "Basic verification"],
    cta: "Start Free",
  },
  {
    name: "Pro",
    price: "$29.99",
    cadence: "/mo",
    description: "Perfect for individuals owning sales and delivery docs.",
    features: [
      ...getPlanFeaturesForDisplay("pro"),
      "Premium AI model",
      "Team collaboration",
    ],
    highlight: true,
    cta: "Upgrade to Pro",
  },
  {
    name: "Pro Plus",
    price: "$49.99",
    cadence: "/mo",
    description: "For power users and pods shipping high-volume docs.",
    features: [
      ...getPlanFeaturesForDisplay("pro-plus"),
      "Premium AI model",
      "AI Notetaker",
      "AI Transcription",
      "Team collaboration",
      "Priority support",
    ],
    cta: "Upgrade to Pro Plus",
  },
  {
    name: "Enterprise",
    price: "Custom",
    cadence: "",
    description: "Custom deployments, integrations, and SLAs.",
    features: [
      "Unlimited everything",
      "Dedicated support",
      "Custom integrations",
      "AI Notetaker",
      "AI Transcription",
      "SLA guarantee",
      "On-premise / hybrid options",
    ],
    cta: "Contact Sales",
  },
];
